import React from 'react';
import styles from './CloseButton.module.scss';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
interface Props {
  callback: () => void;
}

const CloseButton: React.FC<Props> = ({ callback }) => (
  <div
    className={` ${styles.closeButton}`}
    onClick={() => {
      callback();
    }}
  >
    <FontAwesomeIcon icon={faXmark as IconProp} className=" text color-light " />
  </div>
);

export default CloseButton;
